import React, { useEffect, useState } from "react";
import "./index.css";
import { Form, Input, Button, Alert, Image, Radio, Space } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  LoginOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { doLogin, images_folder, isLoggedIn } from "./client";
import { renderElements } from "./FormPart";
import { Link } from "react-router-dom";
import { getURL } from "./client";
import dayjs from "dayjs";

const SignInForm = (props) => {
  const [visible, setVisible] = useState(false);

  const getApplicationType = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const type = queryParameters.get("type") || "";
    return type;
  };
  const validateDate = (testDate) => {
    const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
    return date_regex.test(testDate);
  };
  useEffect(() => {
    props.setLoggedIn(isLoggedIn());
    const form = JSON.parse(localStorage.getItem("form"));
    const progress = JSON.parse(localStorage.getItem("progress"));
    const menu = JSON.parse(localStorage.getItem("menu"));
    const openMenu = JSON.parse(localStorage.getItem("openMenu"));
    const welcomeMessage = JSON.parse(localStorage.getItem("welcomeMessage"));
    const applicationHeader = JSON.parse(
      localStorage.getItem("applicationHeader")
    );

    let formData = JSON.parse(localStorage.getItem("formData"));
    const previousFormId = JSON.parse(localStorage.getItem("previousFormId"));
    const canGoBack = JSON.parse(localStorage.getItem("canGoBack"));
    if (previousFormId) props.setPreviousFormId(previousFormId);
    if (canGoBack) props.setCanGoBack(canGoBack);
    if (formData) {
      for (const [key, value] of Object.entries(formData)) {
        if (validateDate(value)) {
          formData[key] = dayjs(formData[key], "MM/DD/YYYY");
        }
      }
      props.setFormData(formData);
    }
    if (form) props.setForm(renderElements(form));
    if (progress) {
      props.setActiveMenuItem("sub_sub" + progress.step);
      props.setProgress(progress);
    }
    if (menu) props.setMenu(menu);
    if (openMenu) props.setOpenMenu([openMenu]);
    if (welcomeMessage) props.setWelcomeMessage(welcomeMessage);
    if (applicationHeader) props.setApplicationHeader(applicationHeader);
  });

  const onFinish = (values) => {
    props.setSpin(true);
    setVisible(false);
    doLogin(values)
      .then((res) => res.json())
      .then((data) => {
        if (data.uid !== "") {
          const openMenuIndex = data.progress.step.split("_")[0] - 1;
          localStorage.setItem("uid", JSON.stringify(data.uid));
          localStorage.setItem("token", JSON.stringify(data.token));
          localStorage.setItem("menu", JSON.stringify(data.menu));
          localStorage.setItem("progress", JSON.stringify(data.progress));
          localStorage.setItem("form", JSON.stringify(data.form));
          localStorage.setItem("formData", JSON.stringify(data.form_data));
          localStorage.setItem(
            "applicationType",
            JSON.stringify(values.applicationType)
          );
          for (const [key, value] of Object.entries(data.form_data)) {
            if (validateDate(data.form_data[key])) {
              data.form_data[key] = dayjs(value, "MM/DD/YYYY");
            }
          }

          localStorage.setItem(
            "previousFormId",
            JSON.stringify(data.previous_form_id)
          );
          localStorage.setItem("canGoBack", JSON.stringify(data.can_go_back));
          localStorage.setItem(
            "openMenu",
            JSON.stringify("sub" + openMenuIndex)
          );
          localStorage.setItem(
            "welcomeMessage",
            JSON.stringify(data.welcomeMessage)
          );
          localStorage.setItem(
            "applicationHeader",
            JSON.stringify(data.applicationHeader)
          );

          localStorage.setItem(
            "currentFormId",
            JSON.stringify(data.current_form_id)
          );
          if (data.current_form_id === "4_1") {
            props.setStripeClientSecret(data.form_data["client_secret"]);
            props.setStripePublicKey(data.form_data["public_key"]);
            localStorage.setItem(
              "stripeClientSecret",
              JSON.stringify(data.form_data["client_secret"])
            );
            localStorage.setItem(
              "stripePublicKey",
              JSON.stringify(data.form_data["public_key"])
            );
          }
          props.setMenu(data.menu);
          props.setProgress(data.progress);
          if (data.form) props.setForm(renderElements(data.form));
          props.setFormData(data.form_data);
          props.setLoggedIn(isLoggedIn());
          props.setActiveMenuItem("sub_sub" + data.progress.step);
          props.setOpenMenu(["sub" + openMenuIndex]);
          props.setPreviousFormId(data.previous_form_id);
          props.setCanGoBack(data.can_go_back);
          props.setWelcomeMessage(data.welcomeMessage);
          props.setApplicationHeader(data.applicationHeader);

          props.setCurrentFormId(data.current_form_id);
        } else {
          setVisible(true);
        }
      })
      .finally((func) => {
        props.setSpin(false);
      });
  };

  let sign_in_form, selectedApplicationType;

  if (getApplicationType() === "greencard") {
    sign_in_form = (
      <>
        <h3>USA Greencard Application Portal</h3>
        <Image preview={false} src={images_folder("us-flag.png")} />
        <p>
          Use this portal to apply for a <b>USA Greencard</b>. All applications
          will be received and processed on your behalf by Princess Obome
          Foundation.
        </p>
      </>
    );
    selectedApplicationType = (
      <>
        <Form.Item
          name="applicationType"
          initialValue="greencard"
          style={{ display: "none" }}
        >
          <input type="hidden" />
        </Form.Item>
      </>
    );
  } else if (getApplicationType() === "uk-visa") {
    sign_in_form = (
      <>
        <h3>UK Visa Application Portal</h3>
        <Image preview={false} src={images_folder("uk-flag.png")} />
        <p>
          Use this portal to apply for a <b>UK Visa</b>. All applications will
          be received and processed on your behalf by Princess Obome Foundation.
        </p>
      </>
    );
    selectedApplicationType = (
      <>
        <Form.Item
          name="applicationType"
          initialValue="uk-visa"
          style={{ display: "none" }}
        >
          <input type="hidden" />
        </Form.Item>
      </>
    );
  } else if (getApplicationType() === "schengen-visa") {
    sign_in_form = (
      <>
        <h3>Schengen Visa Application Portal</h3>
        <Image preview={false} src={images_folder("schengen-flag.png")} />
        <p>
          Use this portal to apply for a <b>Schengen Visa</b>. All applications
          will be received and processed on your behalf by Princess Obome
          Foundation.
        </p>
      </>
    );
    selectedApplicationType = (
      <>
        <Form.Item
          name="applicationType"
          initialValue="schengen-visa"
          style={{ display: "none" }}
        >
          <input type="hidden" />
        </Form.Item>
      </>
    );
  } else {
    sign_in_form = (
      <>
        <Image preview={false} src={images_folder("us-flag.png")} />
        <Image preview={false} src={images_folder("uk-flag.png")} />
        <Image preview={false} src={images_folder("schengen-flag.png")} />
        <p>
          You can apply for <b>USA Greencard</b>, <b>UK Visa</b>,
          <b> and Schengen Visa</b> through this portal. All applications will
          be received and processed by Princess Obome Foundation.
        </p>
      </>
    );
    selectedApplicationType = (
      <>
        <p>What are you applying for?</p>
        <Form.Item
          name="applicationType"
          initialValue={getApplicationType()}
          rules={[
            {
              required: true,
              message: "Please select application type!",
            },
          ]}
        >
          <Radio.Group>
            <Space direction="vertical">
              <Radio value={"greencard"}>USA Greencard</Radio>
              <Radio value={"us-visa"}>USA Visa</Radio>
              <Radio value={"uk-visa"}>UK Visa</Radio>
              <Radio value={"schengen-visa"}>Schengen Visa</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
      </>
    );
  }
  return (
    <React.Fragment>
      <div className="sign-in-intro">{sign_in_form}</div>
      <Form name="normal_login" className="login-form" onFinish={onFinish}>
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: "Please input your email address!",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Email address"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your Password!",
            },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            autoComplete="off"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>
        {visible && (
          <Alert
            style={{ marginBottom: "25px" }}
            message="Invalid username or password"
            description=""
            showIcon
            type="error"
          />
        )}
        {selectedApplicationType}
        <Form.Item>
          <Button
            block
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            <LoginOutlined /> Sign In
          </Button>
        </Form.Item>
        <Link to={getURL("/forgot-password")}>Forgot your password?</Link>
        <br />
        <br />
        <p>
          <Link to={getURL("/create-account")}>
            <Button block type="default" className="login-form-button">
              <UserAddOutlined />
              Create New Account
            </Button>
          </Link>
        </p>
      </Form>
    </React.Fragment>
  );
};

export default SignInForm;
